import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../core';
import { Cliente } from '../cliente';

@Injectable({
    providedIn: 'root'
})
export class ClienteSecundarioHttpService {
    resource = 'cliente';
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/${this.resource}`;
    }

    /** Cria o cliente secundário a partir do cliente primário informado */
    createClienteSecundario(idClientePrimario: number): Observable<Cliente> {
        return this.customHttp.get<Cliente>(`${this.pathApi}/${idClientePrimario}/clientesecundario`);
    }
}
